const styles = {
  container: {
    padding: '20px 0'
  },
  links: {
    display: 'flex',
    padding: '0',
    margin: '0',
    listStyle: 'none',
    justifyContent: 'center'
  }
}

export default styles
